import React, { Component } from 'react';
import { Popover, Input, Modal, Icon, Button, Checkbox, Radio, Transfer, Select } from 'antd';
// import Row from './row';
// import Col from './col';
import SvgIcon from 'SvgIcon';
import * as  eChartCommon from '../echart/eChartCommon';
import * as  eChartProxy from '../echart/eChartProxy';

const RadioGroup = Radio.Group;
export default class PublishMenu extends React.Component {
  constructor(props) {
    super(props);
    const { viewModel } = props;
    this.state = {
      bShowCard: false,
      params: {},
      content: null,
      canPublishToMobile: false,
      selected: [],
      defaultRadio: 1
    }
    this.randomKey = "_" + Math.floor(Math.random() * 10000000000);
  }

  componentDidMount() {
    let self = this;
    this.props.viewModel.on('setPublishMenuInfo', (params) => {
      self.setState({ params });
    });
    this.canPublishToMobile(this.props.viewModel.getParams().filterId);
  }
  canPublishToMobile = (filterId) => {
    let self = this;
    // filterId = filterId || 14414907;
    let callback = (json) => {
      if (json.code === 200 && json.data && json.data.length > 0) {
        self.setState({ canPublishToMobile: true });
      }
      else {
        self.setState({ canPublishToMobile: false });
        eChartCommon.LogChartInfo("当前报表没有移动过滤方案，不能发布到移动端。filterId ", filterId, 999);
      }
    }
    eChartProxy.doProxy_Options("filterDesign/getSolutionList?terminalType=3", 'POST', { filterId }, callback, { terminalType: false });

  }
  render() {
    let self = this;
    let type = self.state.bShowCard ? "up" : "down";
    let content = self.getPublishMenuCard();
    let className = this.props.className;

    let conditionPop = (
      <div style={{ float: "left" }} className={className} >
        <Popover
          placement="bottom"
          overlayClassName=""
          content={content}
          trigger={"click"}
          visible={self.state.bShowCard}
          onVisibleChange={(visible) => self.onCardVisibleChange(visible, self)}
        >
          <Button
            onClick={() => self.ShowCard()}
            type={type}
          >
            <SvgIcon type="fabufangan" className={"icon-fabufangan"} />
            <span>{self.props.name ? self.props.name : "发布菜单"}</span>
          </Button>
        </Popover>
      </div>
    );
    return conditionPop;
  }

  onCardVisibleChange(visible, self) {
    let { selected } = this.state;
    if (visible == false) {
      self.setState({ bShowCard: false });
    }
  }


  ShowCard() {
    let bShowCard = !this.state.bShowCard;
    if (bShowCard) {
      this.setState({ params: {}, content: {}, bShowCard: true });
      this.props.viewModel.execute('getPublishMenuInfo');
    }
    else {
      this.setState({ params: {}, bShowCard: false });
    }
  }
  mustSelect = (e) => {
    let { selected } = this.state;
    if (selected.includes(e.target.value)) {
      selected.splice(selected.indexOf(e.target.value), 1);
    }
    else {
      selected.push(e.target.value)
    }
    this.setState({ selected })
  }
  radioChange = (e) => {
    this.judgeChange(e)
  }
  getPublishMenuCard() {

    let self = this;
    let content = self.state.content;
    let params = self.state.params;
    if (self.state.bShowCard == true && _.isEmpty(params) == false) {

      // let name = self.state.params.name;
      // let groupSchemaName = self.state.groupSchemaName;
      let name = params.name;
      let groupSchemaName = params.groupSchemaName ? params.groupSchemaName : "";

      content = <div className="publishMenu" key={"MenuKey_" + params.groupSchemaId ? params.groupSchemaId : "Null"} >
        <div className={"publishMenu_count  publishMenu_count" + this.randomKey}>
          <span>方案名称:</span>
          <Input
            id={"publishMenu_Title" + this.randomKey}
            placeholder="请输入"
            defaultValue={name + "_" + groupSchemaName}
          />
          <div className="pc-mobile-show pc-mobile-show-margin">
            <Checkbox disabled={!self.state.params.isPc} value={"1"} onChange={this.mustSelect} checked={this.state.selected.includes("1")} className={"publishMenu_Pc publishMenu_Pc" + this.randomKey} defaultChecked={false}>PC端展现</Checkbox>
          </div>

          {self.state.canPublishToMobile ? <div className="pc-mobile-show"   >
            <Checkbox disabled={!self.state.params.isMobile} value={"3"} onChange={this.mustSelect} checked={this.state.selected.includes("3")} className={"publishMenu_Mobile publishMenu_Mobile" + this.randomKey} defaultChecked={false}>移动端展现</Checkbox>
          </div> : <div />}
          <div>
            <RadioGroup value={this.state.defaultRadio} onChange={this.radioChange} className="power_group">
              <Radio className="old_power" value={1}>沿用原报表权限</Radio>
              <Radio className="new_power" value={2}>生成新权限</Radio>
            </RadioGroup>
          </div>
        </div>
        <div className="footer-btn">
          <Button type={"primary"} onClick={() => this.handleOk()}>确定</Button>
          <Button type={"default"} onClick={() => this.handleCancel()}>取消</Button>
        </div>
      </div>
      self.state.content = content;
    }
    return content;

  }

  judgeChange = (e) => {
    let ele = document.getElementById('publishMenu_Title' + this.randomKey);
    // let arr = document.getElementsByClassName("publishMenu_Mobile");
    // let arr2 = document.getElementsByClassName("publishMenu_Pc");
    // let isMobile = arr && arr[0] && arr[0].control.checked || false;
    // let isPc = arr2[0].control.checked;
    let self = this;
    let { selected } = this.state
    let name = ele.value;
    let outerparams = { menu_name: name };
    let outercallback = (json) => {
      if (json.code === 200) {
        if (json.data && json.data.length === 0) {
          self.setState({ defaultRadio: e.target.value })
          // this.setState({judgeData:json.data})
        }
        else {
          if (json.data.length > 0) {
            let pc = json.data.filter(v => v.terminalType === "1")
            let mobile = json.data.filter(v => v.terminalType === "3")
            if (pc.length > 0 && mobile.length > 0) {
              cb.utils.alert("该名称已存在PC端和移动端不可修改权限");
            }
            else {
              if (pc.length > 0) {
                cb.utils.alert("该名称已存在PC端不可修改权限");
              }
              if (mobile.length > 0) {
                cb.utils.alert("该名称已存在移动端不可修改权限");
              }
            }
          }
        }

      }
    }
    eChartProxy.doProxy(eChartProxy.url.menuExists, 'GET', outerparams, outercallback);
  }


  handleOk = (e) => {
    let self = this;
    let { selected } = self.state
    if (selected.includes("1") || selected.includes("3")) {
      if (self.isHandleOking == true) {
        return;
      }
      self.isHandleOking = true;
      let ele = document.getElementById('publishMenu_Title' + this.randomKey);
      let arr = document.getElementsByClassName("publishMenu_Mobile" + this.randomKey);
      let arr2 = document.getElementsByClassName("publishMenu_Pc" + this.randomKey);
      let isMobile = arr && arr[0] && arr[0].control.checked || false;
      let isPc = arr2 && arr2[0] && arr2[0].control.checked;
      let name = ele.value;
      if (name == "" || name.length > 16) {
        cb.utils.alert("名称不可为空且长度小于16个字。");
        self.isHandleOking = false;
        return;
      }
      let outerparams = { menu_name: name };
      let outercallback = (json) => {
        if (json.code === 200) {
          if (!!json.data && json.data.length > 0 ) {
            let pc = json.data.filter(v=>v.terminalType === "1")
            let mobile = json.data.filter(v=>v.terminalType === "3")
            let authCode = pc.length&&pc[0].authCode || mobile.length&&mobile[0].authCode || ""
            let pcCode = pc.length&&pc[0].menu_code
            let mobileCode = mobile.length&&mobile[0].menu_code
            let pctype = pc.length && pc[0].terminalType
            let mobiletype = mobile.length && mobile[0].terminalType
            let pcAddauth = pc.length && pc[0].addAuth
            let mobileAddauth = mobile.length && mobile[0].addAuth
            if (json.data.isSystem == true) {
              cb.utils.alert("新发布的报表名字不可与系统报表重名。");
              self.isHandleOking = false;
            }
            else {
              if (pc.length > 0 && mobile.length > 0) {
                let tips = '已经存在当前菜单，是否覆盖PC端和移动端？'
                if (selected.includes(pctype) && selected.includes(mobiletype)) {
                  pcAddauth && mobileAddauth ? self.setState({ defaultRadio: 2 }) : self.setState({ defaultRadio: 1 })
                }
                if (selected.includes(pctype) && !selected.includes(mobiletype)) {
                  tips = '已经存在当前菜单，是否覆盖PC端';
                  let auth = pcAddauth ? 2 : 1
                  self.setState({ defaultRadio: auth })
                }
                if (!selected.includes(pctype) && selected.includes(mobiletype)) {
                  tips = '已经存在当前菜单，是否覆盖移动端';
                  let auth = mobileAddauth ? 2 : 1
                  self.setState({ defaultRadio: auth })
                }
                cb.utils.confirm(tips, function () {
                  let newName = name
                  self.saveMenu(newName, pcCode,mobileCode,authCode, isMobile, isPc);
                }, function () {
                  self.isHandleOking = false;
                });
              }
              else {
                if (pc.length > 0) {
                  let auth = pcAddauth ? 2 : 1;
                  self.setState({ defaultRadio: auth })
                  let newName = name;
                  // if(selected.includes(pctype) && selected.includes("3")){
                  //   newName = name + "pc和移动端"
                  // }
                  // else{
                  //   if(selected.includes(pctype)){
                  //     newName = name + "pc端"
                  //   }
                  //   if(selected.includes("3")){
                  //     newName = name + "移动端"
                  //   }
                  // }
                  selected.includes(pctype) ?
                    cb.utils.confirm('已经存在当前菜单，是否覆盖PC端？', function () {
                      self.saveMenu(newName, pcCode, "", authCode, isMobile, isPc);
                    }, function () {
                      self.isHandleOking = false;
                    })
                    :
                    self.saveMenu(newName, "", "", authCode, isMobile, isPc);
                }
                if (mobile.length > 0) {
                  let auth = mobileAddauth ? 2 : 1;
                  self.setState({ defaultRadio: auth })
                  let newName = name;
                  // if(selected.includes("1") && selected.includes(mobiletype)){
                  //   newName = name + "(pc和移动端)"
                  // }
                  // else{
                  //   if(selected.includes("1")){
                  //     newName = name + "(pc端)"
                  //   }
                  //   if(selected.includes(mobiletype)){
                  //     newName = name + "(移动端)"
                  //   }
                  // }
                  selected.includes(mobiletype) ?
                    cb.utils.confirm('已经存在当前菜单，是否覆盖移动端端？', function () {
                      self.saveMenu(newName, "", mobileCode, authCode, isMobile, isPc);
                    }, function () {
                      self.isHandleOking = false;
                    })
                    :
                    self.saveMenu(newName, "", "", authCode, isMobile, isPc);
                }
              }
            }
          }
          else {
            self.saveMenu(name, "","","", isMobile, isPc);
          }
        }
        else {
          self.isHandleOking = false;
        }

      }
      eChartProxy.doProxy(eChartProxy.url.menuExists, 'GET', outerparams, outercallback);

    }
    else {
      cb.utils.alert("请选择PC或移动");
    }
  }
  saveMenu = (name, pcCode, mobileCode, authCode, isMobile, isPc) => {
    eChartCommon.LogChartInfo("发布报表方案saveMenu 参数 name = " + name + " pc_code = " + pcCode + " mobile_code = " + mobileCode, "", 999);
    let self = this;
    let billnum = self.state.params.billnum;
    let addAuth = self.state.defaultRadio == "1" ? false : true;
    const filterViewModel = this.props.viewModel.getCache('FilterViewModel');
    const predicateValue = filterViewModel && filterViewModel.getCache('predicateValue');
    let currentCondition = self.state.params.condition;
    if (predicateValue && currentCondition && currentCondition.commonVOs && currentCondition.commonVOs.length) {
      currentCondition = JSON.parse(JSON.stringify(currentCondition));
      currentCondition.commonVOs.forEach(item => {
        if (!predicateValue[item.itemName]) return;
        item.value1 = predicateValue[item.itemName];
        delete item.value2;
      });
    }
    let condition = JSON.stringify(currentCondition);
    let params = { billnum, name, condition, isMobile, isPc, addAuth };
    if (!!pcCode && !!mobileCode) {
      params.pc_menu_code = pcCode;
      params.mobile_menu_code = mobileCode;
      // authCode ? params.authCode = authCode : null
    }
    else {
      if (!!pcCode) {
        params.pc_menu_code = pcCode;
        // authCode ? params.authCode = authCode : null
      }
      if (!!mobileCode) {
        params.mobile_code = mobileCode;
        // authCode ? params.authCode = authCode : null
      }
    }
    if (!!self.state.params.groupSchemaId)
      params.groupSchemaId = self.state.params.groupSchemaId;
      authCode?  params.authCode  = authCode : null
    let callback = (json) => {
      self.isHandleOking = false;
      if (json.code === 200) {
        cb.utils.alert("报表方案已发布。");
        self.setState({ bShowCard: false });
      }
      else {
        eChartCommon.LogChartInfo("发布报表方案失败。err ", json.message, 999);
        cb.utils.alert(json.message);
        self.setState({ bShowCard: false });
      }
    }
    eChartProxy.doProxy(eChartProxy.url.publishMenu, 'POST', params, callback);
  }
  handleCancel = (e) => {
    this.setState({ bShowCard: false });
  }

}





// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/publishmenu.jsx